module.exports = __webpack_public_path__ + "img/headportrait_4icon.edc81bf5.png";